<template>
  <el-form ref="filter" :inline="true" :model="filter">
    <div class="filter-container">
      <el-form-item label="手機">
        <el-input placeholder="請輸入" v-model="filter.mobile_phone"></el-input>
        <el-button
          type="primary"
          @click="searchUsers({ mobile_phone: filter.mobile_phone })"
          :disabled="!filter.mobile_phone"
        >
          搜尋
        </el-button>
      </el-form-item>
      <el-form-item label="住家電話">
        <el-input placeholder="請輸入" v-model="filter.telephone"></el-input>
        <el-button
          type="primary"
          @click="searchUsers({ telephone: filter.telephone })"
          :disabled="!filter.telephone"
        >
          搜尋
        </el-button>
      </el-form-item>
      <el-form-item label="姓名">
        <el-input placeholder="請輸入" v-model="filter.name"></el-input>
        <el-button
          type="primary"
          @click="searchUsers({ name: filter.name })"
          :disabled="!filter.name"
        >
          搜尋
        </el-button>
      </el-form-item>
    </div>

    <template
      v-if="availableUsers instanceof Array && availableUsers.length > 0"
    >
      <div class="table-responsive">
        <table class="table table-hover">
          <thead>
            <tr>
              <th>編號</th>
              <th>姓名</th>
              <th>地址</th>
              <th>動作</th>
              <th colspan="2"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="user in availableUsers" :key="user.id">
              <td>
                <span>{{ user.id }}</span>
              </td>
              <td>
                <span>{{ user.name }}</span>
              </td>
              <td>
                <span>{{ user.address }}</span>
              </td>
              <td>
                <el-button
                  type="primary"
                  size="mini"
                  @click="confirmUser(user.id)"
                >
                  選取
                </el-button>
              </td>
              <td></td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>
    </template>

    <slot>
      <div v-if="value" class="order-info-section">
        <h2 class="title"><span>乘客資訊</span></h2>
        <div class="table-responsive">
          <table class="table">
            <tbody>
              <tr>
                <td class="text-right">乘客姓名</td>
                <td>{{ value.name }}</td>
              </tr>
              <tr>
                <td class="text-right">地址</td>
                <td>{{ value.address }}</td>
              </tr>
              <tr>
                <td class="text-right">自付比例</td>
                <td>{{ value.payForOwnselfProportion || 0 }}%</td>
              </tr>
              <tr>
                <td class="text-right">剩餘補助</td>
                <td>{{ value.subsidyLastAmount || 0 }}</td>
              </tr>
              <tr>
                <td class="text-right">社區式剩餘次數</td>
                <td>{{ value.lastCommunityShuttleFrequency || 0 }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </slot>
  </el-form>
</template>

<script>
import longTermCareService from '@/API/longTermCareService'

const initial_filter = {
  telephone: null,
  mobile_phone: null,
  name: null,
}

export default {
  props: ['value'],
  data() {
    return {
      filter: { ...initial_filter },
      availableUsers: [],
    }
  },
  methods: {
    searchUsers(params) {
      longTermCareService
        .searchUsers(params)
        .then(({ result, message }) => {
          this.$message.success(message)
          this.availableUsers = result
          return result
        })
        .catch(({ data: { error }, message }) =>
          this.$message.error(message || error.message),
        )
    },
    confirmUser(userId) {
      longTermCareService
        .getUserById(userId)
        .then(({ result }) => {
          this.availableUsers = []
          this.filter = { ...initial_filter }
          this.$emit('input', {
            id: userId,
            ...result,
          })
        })
        .catch((err) => {
          this.$message.error('無效用戶')
        })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/longterm-care.scss';

.filter-container {
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/pages/longTermCare/UserSelector.vue